import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { ControlProps } from '@/app/components/search/components/Form';
import { getMultilistboxValue, OPTIONS_SORT } from '../utils';
import getListboxContainer from './getListboxContainer';
import FilterContainer from '../FilterContainer';
import type { CommonProps } from './CommonProps';

type GetBeachTypeField = {
  searchParams: SearchParams;
  commonProps: CommonProps;
  t: TranslationFunction;
};

export const getBeachTypeOptions = ({ t, isWaiting }: { t: TranslationFunction; isWaiting?: boolean }) => [
  { value: 1, label: t('vacation.oss.filters.beach_type.white_sand'), disabled: isWaiting },
  { value: 2, label: t('vacation.oss.filters.beach_type.sand'), disabled: isWaiting },
  { value: 3, label: t('vacation.oss.filters.beach_type.pebbles'), disabled: isWaiting },
];

export const getBeachTypeField = ({ t, searchParams, commonProps }: GetBeachTypeField): ControlProps =>
  getListboxContainer({
    fieldName: URLParameters.BEACH_TYPE,
    containerName: FilterContainer.BeachTypeContainer,
    containerTitle: t('vacation.oss.filters.beach_type.title'),
    options: getBeachTypeOptions({ t, isWaiting: commonProps.isWaiting }),
    value: getMultilistboxValue(searchParams[URLParameters.BEACH_TYPE], true),
    fieldClassName: '',
    optionsSort: OPTIONS_SORT.ALPHABET,
    ...commonProps,
  });
